import { render, staticRenderFns } from "./SalesHotline.vue?vue&type=template&id=339d6619&"
import script from "./SalesHotline.vue?vue&type=script&lang=js&"
export * from "./SalesHotline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports